import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import heroBg from "../../images/graphics/heroBg.svg";
import heroImg from "../../images/photos/heroImg.png";

function Hero({ pageWidth }) {
  // Parallax Effect
  const [offset, setOffset] = useState(0);
  const parallaxScroll = () => {
    setOffset(window.scrollY);
  };
  useEffect(() => {
    window.addEventListener("scroll", parallaxScroll);
    return () => window.removeEventListener("scroll", parallaxScroll);
  }, [offset]);
  const parallaxStyle = {
    transform:
      pageWidth > 480
        ? `translate(0, ${offset * 0.04}px)`
        : `translate(50%, ${offset * 0.08}px)`,
  };
  const parallaxStyleText = {
    transform:
      pageWidth >= 480
        ? `translate(0, ${offset * -0.1}px)`
        : `translate(0, ${offset * -0.07}px)`,
  };
  // End Parallax

  return (
    <ScHero>
      <h2 className="heroText" style={parallaxStyleText}>
        We’re a performance <br />
        <span>driven marketing agency</span>
      </h2>
      <h3 className="subHeroText" style={parallaxStyleText}>
        Where good businesses become iconic brands
      </h3>
      <button className="cta" style={parallaxStyleText} tabIndex={-1}>
        <NavLink to="/Services" tabIndex={1}>
          Boom Your Brand
        </NavLink>
        <FontAwesomeIcon icon={faChevronRight} className="faIcon" />
      </button>
      <figure className="heroImgContainer" style={parallaxStyle}>
        <img src={heroImg} alt="" className="heroImg" />
      </figure>
      <figure className="bgContainer">
        <img src={heroBg} alt="" className="heroBg" />
      </figure>
    </ScHero>
  );
}

const ScHero = styled("section")`
  height: 100vh;
  min-height: 36rem;
  background: var(--offWhite);

  > * {
    position: absolute;
  }
  .heroText {
    color: var(--dark);
    top: 26%;
    left: 6%;
    font-size: calc(1.4rem + 3.2vw);
    font-weight: 400;
    line-height: 94%;
    z-index: 3;
    transition: transform 0.6s cubic-bezier(0.23, 0.79, 0.68, 0.96);
    span {
      font-size: calc(1.2rem + 2.4vw);
      font-weight: 400;
    }
  }
  .subHeroText {
    /* border: 1px solid yellow; */
    top: 48%;
    left: 6%;
    /* width: 32%; */
    width: calc(16rem + 16vw);
    font-size: calc(1rem + 1vw);
    font-weight: 100;
    z-index: 3;
    transition: transform 0.6s cubic-bezier(0.23, 0.79, 0.68, 0.96);
  }

  .cta {
    position: relative;
    top: 68%;
    left: 7%;
    z-index: 3;
    transition: transform 0.5s cubic-bezier(0.23, 0.79, 0.68, 0.96);
    a {
      color: var(--dark);
      font-size: calc(0.8rem + 0.8vw);
      font-weight: 400;
      transition: color 0.4s ease 0.2s;
    }
    .faIcon {
      color: var(--dark);
      position: absolute;
      top: 50%;
      right: -6%;
      transform: translate(100%, -50%);
      font-size: calc(0.6rem + 0.6vw);
      transition: transform 0.4s cubic-bezier(0.54, -0.85, 0.45, 1.67);
    }
    &::before {
      content: "";
      position: absolute;
      top: 50%;
      left: -12%;
      transform: translate(0%, -50%);
      width: 4rem;
      height: 4rem;
      border-radius: 12rem;
      background: var(--light);
      z-index: -1;
      pointer-events: none;
      transition: 0.4s cubic-bezier(0.42, -0.49, 0.64, 1.24);
    }
    &:hover {
      a {
        /* color: var(--light); */
      }
      .faIcon {
        transform: translate(250%, -50%);
        transition-delay: 0.16s;
      }
      &::before {
        width: 124%;
        /* background: var(--offDark); */
      }
    }
  }

  .heroImgContainer {
    top: 12%;
    right: 2%;
    transform: translate(0, 0);
    width: 50vw;
    z-index: 2;
    transition: transform 1s cubic-bezier(0.17, 0.67, 0.43, 1);
    .heroImg {
      width: 100%;
    }
  }

  .bgContainer {
    top: 0;
    width: 100vw;
    height: 100vh;
    min-height: 36rem;
    z-index: 1;
    overflow: hidden;
    .heroBg {
      transform: translate(0, -6%);
      width: calc(20rem + 36vw);
    }
  }

  @media (max-width: 1440px) {
    .heroImgContainer {
      top: 16%;
    }
  }

  // MAX HEIGHT
  @media (max-height: 624px) {
    .heroText {
      top: 28%;
    }
    .subHeroText {
      top: 56%;
    }
    .cta {
      top: 80%;
    }
    .heroImgContainer {
      top: 28%;
      right: 6%;
      width: 36vw;
    }
  }

  @media (max-width: 1224px) {
    .heroImgContainer {
      top: 20%;
    }
    .bgContainer {
      .heroBg {
        transform: translate(0, 0);
      }
    }
  }

  @media (max-width: 1024px) {
    .subHeroText {
      top: 46%;
    }
    .cta {
      top: 68%;
    }
    .heroImgContainer {
      top: 32%;
    }

    .bgContainer {
      .heroBg {
        width: auto;
        height: 112%;
      }
    }
  }

  @media (max-width: 768px) {
    .subHeroText {
      top: 44%;
    }
    .cta {
      top: 60%;
      left: 9%;
      &::before {
        width: 3.2rem;
        height: 3.2rem;
      }
    }
    .heroImgContainer {
      top: 44%;
      width: 60vw;
    }
    .bgContainer {
      .heroBg {
        /* width: auto; */
        /* height: 120%; */
      }
    }
  }

  @media (max-width: 520px) {
    .heroText {
      top: 30%;
    }
    .cta {
      top: 64%;
      &::before {
        width: 2.8rem;
        height: 2.8rem;
      }
    }
    .heroImgContainer {
      top: 52%;
      width: 60vw;
    }
    .bgContainer {
      .heroBg {
        height: 100%;
        min-height: 43rem;
      }
    }
  }

  @media (max-width: 480px) {
    * > {
      transition: 0s;
    }
    .heroText {
      top: 22%;
    }
    .subHeroText {
      top: 34%;
    }
    .cta {
      top: 46%;
      left: 10%;
      transform: translate(0, 100%);
    }

    .heroImgContainer {
      top: 48%;
      right: 50%;
      width: 100%;
    }

    .bgContainer {
      .heroBg {
        height: 100%;
        width: auto;
        transform: translate(0, 0);
      }
    }
  }
`;

export default Hero;
